import { render, staticRenderFns } from "./SignupModal.vue?vue&type=template&id=9be36338&scoped=true"
import script from "./SignupModal.js?vue&type=script&lang=js&external"
export * from "./SignupModal.js?vue&type=script&lang=js&external"
import style0 from "./SignupModal.scss?vue&type=style&index=0&id=9be36338&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be36338",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default,HotTitle: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Title/Title.vue').default})
